module.exports = __webpack_public_path__ + "img/完善的数据体系bg@2x.2f165d6d.png";